import { colors } from "oolib"
import { queryClient } from "../../.."
import { getAccessControlEnabledPLBModules } from "../../../pageTpls/PlatformBuilder/config"
import { __CheckAccessToModule, __CheckSomeAccessToSomePlatformBuilderModule, __GetAccessibleContentTypes, __IsAdmin, __IsSuperAdmin } from "../../../utils/accessControl"
import { pluginConfigs } from "../../../Plugins/_EXPORTS"
import { getTenant } from "@/TENANT_CONFIGS"

export const genMyDashboardMenuOptions = userData => {
    const {deployment : {
       _EnableParticipantManager
    }} = queryClient.getQueryData('platformConfigs')
  
    let profileSettingsLink =  {
      display: 'Profile Settings', 
      icon: 'GearSix', 
      link: `/my-dashboard/MyProfile`
    }
  
    
  
    let platformBuilderLink =  (
      (__CheckSomeAccessToSomePlatformBuilderModule({
        user: userData?.user,
        actions: ['READ', 'UPDATE'],
        modules: getAccessControlEnabledPLBModules().map(m => m.value)
      }) || __CheckAccessToModule(userData?.user, 'READ', 'usersManager')) && 
      {
        display: 'Admin Dashboard', 
        icon: 'Wrench', 
        link: `/platformBuilder`,
        // style:{ border: `1px solid ${colors.white}`}
      }
    )
  
    
  
    let myPublishedLink =  { 
      display: 'My Content', 
      icon: 'Table',
      link: `/my-dashboard/MyContent`
    }
  
    let myDraftsLink = { 
      display: 'Drafts', 
      link: `/my-dashboard/MyContent?activeTab=draft`
    }
  
    let myInModerationLink = { 
      display: 'In Moderation', 
      link: `/my-dashboard/MyContent?activeTab=inReview`
    }
  
    let modDashboardLink = userData?.user &&
      __GetAccessibleContentTypes({user:userData?.user, ACTION:'MODERATE'}).length > 0 &&
      { 
        display: "Review Dashboard", 
        icon: "CheckSquareOffset",
        link: "/my-dashboard/ModQueue" 
      }
  
      let participantManager = _EnableParticipantManager && 
      {
          display: 'Participant Manager',
          icon: 'Cards',
          link: '/my-dashboard/ParticipantManager',
      }
  
      
                            
    
       
    const pluginTabs = pluginConfigs[getTenant()]?.MyDashboardTabs || {};
    const pluginTabLinks = Object.values(pluginTabs)
      .filter((t) => (t.shouldShow ? t.shouldShow(userData?.user) : true))
      .map((t) => ({
        display: t.display,
        icon: t.icon,
        link: `/my-dashboard/${t.sectionId}`,
      }));

    return [
      {
        id: 'pluginTabs',
        links: pluginTabLinks,
      },
      {
        // id : 'myContent',
        // title : 'My Content',
        links : [
          ...([myPublishedLink].filter(Boolean)),
          // ...([myDraftsLink].filter(Boolean)),
          // ...([myInModerationLink].filter(Boolean)),
        ]
      },
      {
        id: 'myAccount',
        links : [
          ...([profileSettingsLink].filter(Boolean)),
        ]
      },
      {
        id : 'primaryLinks',
        links : [
          ...([participantManager].filter(Boolean)),
        ]
      },
      {
        id: 'advancedDashboards',
        links : [
          ...([modDashboardLink].filter(Boolean)),
          ...([platformBuilderLink].filter(Boolean))
        ]
      }
    ].filter(d => d.links.length > 0);
  }